module.exports = __webpack_public_path__ + "static/media/goblin_bomber_head.b1438bbe.svg";